import type { TFunction } from 'i18next';

import type { Event } from '@feathr/blackbox';

export interface IEmailHistoryData {
  /** Set of project IDs that have email delivery history */
  projectIdsWithEmailHistory: Set<string>;
  /** Whether the email history data is still loading */
  isLoading: boolean;
}

export function hasEmailHistory(
  projectId: string,
  projectIdsWithEmailHistory: Set<string>,
): boolean {
  return projectIdsWithEmailHistory.has(projectId);
}

export function filterProjects(
  projects: Event[],
  showOnlyEmailedProjects: boolean,
  projectIdsWithEmailHistory: Set<string>,
): Event[] {
  if (!showOnlyEmailedProjects) {
    return projects;
  }

  return projects.filter((project) => projectIdsWithEmailHistory.has(project.id));
}

/**
 * Sorts projects alphabetically by their email preferences alias, falling back to name.
 */
export function sortProjects(projects: Event[]): Event[] {
  return projects.slice().sort((a, b) => {
    const aAlias = a.get('email_preferences_alias');
    const bAlias = b.get('email_preferences_alias');
    const aName = a.get('name') || '';
    const bName = b.get('name') || '';

    const aValue = aAlias || aName;
    const bValue = bAlias || bName;

    return aValue.localeCompare(bValue);
  });
}

export function getProjectCountText(
  t: TFunction,
  visibleCount: number,
  totalCount: number,
): string {
  return t('Showing {{visibleCount}} of {{totalCount}} projects', {
    visibleCount,
    totalCount,
  });
}
